module.exports = __webpack_public_path__ + "img/step4.886686bc.png";